import { formatDate } from '@betterment/core';
import { endOfMonth, endOfYear, startOfMonth, startOfYear, subMonths, subYears } from 'date-fns';

export interface FilterParams {
  dateFilter?: DateFilter | LegacyDateFilter;
  from?: string;
  to?: string;
}

export enum FilterType {
  DateFilter = 'dateFilter',
  FromDate = 'from',
  ToDate = 'to',
}

export enum LegacyDateFilter {
  ThisMonth = 'This month',
  LastMonth = 'Last month',
  ThisYear = 'This year',
  AllTime = 'All time',
}

export enum DateFilter {
  PastMonth = 'Past month',
  Past3Months = 'Past three months',
  YearToDate = 'Year to date',
  PastYear = 'Past year',
  AllTime = 'All time',
  Custom = 'Custom',
}

export function toDateRangeLegacy(filterOption: LegacyDateFilter): { startOn: string; endOn: string } | null {
  if (filterOption === LegacyDateFilter.AllTime) {
    return null;
  }

  const today = new Date();

  switch (filterOption) {
    case LegacyDateFilter.ThisMonth:
      return { startOn: formatDate(startOfMonth(today), 'iso8601'), endOn: formatDate(endOfMonth(today), 'iso8601') };
    case LegacyDateFilter.LastMonth: {
      const lastMonth = subMonths(today, 1);
      return { startOn: formatDate(startOfMonth(lastMonth)), endOn: formatDate(endOfMonth(lastMonth)) };
    }
    case LegacyDateFilter.ThisYear:
      return { startOn: formatDate(startOfYear(today)), endOn: formatDate(endOfYear(today)) };
    default:
      return null;
  }
}

export function toDateRange(
  filterOption: DateFilter,
  from?: string | null,
  to?: string | null
): { startOn: string; endOn: string } | null {
  const today = new Date();

  switch (filterOption) {
    case DateFilter.PastMonth:
      return { startOn: formatDate(subMonths(today, 1), 'iso8601'), endOn: formatDate(today, 'iso8601') };
    case DateFilter.Past3Months:
      return { startOn: formatDate(subMonths(today, 3), 'iso8601'), endOn: formatDate(today, 'iso8601') };
    case DateFilter.YearToDate:
      return { startOn: formatDate(startOfYear(today), 'iso8601'), endOn: formatDate(today, 'iso8601') };
    case DateFilter.PastYear: {
      const pastYear = subYears(today, 1);
      return { startOn: formatDate(pastYear, 'iso8601'), endOn: formatDate(today, 'iso8601') };
    }
    case DateFilter.Custom:
      if (from && to) {
        return { startOn: formatDate(from, 'iso8601'), endOn: formatDate(to, 'iso8601') };
      }
      return null;
    default:
      return null;
  }
}
